import { isFilledObject } from '../../AppHelpers'

export default class CurrentLiveVideoAsset {
  constructor(obj) {
    if (isFilledObject(obj)) {
      this.title = obj.title
      this.status = obj.status
      this.thumb = obj.thumbnail_image
      this.type = 'none'
      this.streamUrl = ''

      if (obj && obj.link && isFilledObject(obj.link)) {
        this.type = obj.link.type ? obj.link.type : 'none'

        if (this.type === 'video') {
          this.streamUrl = obj.link.href
        }
      }
    }
  }
}
